
import {
  defineComponent, onBeforeMount, reactive,
} from 'vue';
import message from 'ant-design-vue/lib/message';
import Card from '@/core/components/UI/Card.vue';
import PreviewPdf from '@/core/components/UI/PreviewPdf.vue';
import { useAppBase } from '@/core/composables/AppBase';
import { IOficio } from '@/models/Entidades/IOficio';
import ComunicacaoApi from '@/core/components/UI/ComunicacaoApi.vue';
import ServicoOficio from '@/servicos/ServicoOficio';
import { EStatusResposta, IResposta } from '@/core/models/IResposta';
import { EStatusOficio } from '@/models/Enumeradores/EStatusOficio';
import storeApp from '@/store/storeApp';
import ServicoApp from '@/servicos/ServicoApp';
import ComboUsuario from '@/components/ComboUsuario.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import EditorHtml from '@/core/components/UI/EditorHtml.vue';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import SelecionarData from '@/core/components/UI/SelecionarData.vue';

export default defineComponent({
  name: 'OficioCadastro',
  components: {
    Card,
    ComunicacaoApi,
    ComboUsuario,
    SelecionarData,
    EditorHtml,
    PreviewPdf,
  },
  setup() {
    const {
      appBase, apresentarComunicacaoApi, apresentarMensagemSucesso, ocultarComunicacaoApi, obterCodigoRota,
    } = useAppBase();
    const servicoOficio = new ServicoOficio();
    const servicoApp = new ServicoApp();
    const state = reactive({
      oficio: {} as IOficio,
      apresentarCampos: false,
      bloquearCampos: false,
      gerarPdf: false,
      gerandoPdf: false,
      arquivosPdf: [] as IArquivoPdf[],
    });

    let debounce = 0;
    function marcarAlterado() {
      state.gerarPdf = false;
    }

    async function obterOficio(codigo:number) {
      appBase.carregando = true;
      state.oficio = await servicoOficio.obter(codigo);
      if (state.oficio.status === EStatusOficio.Excluido || state.oficio.status === EStatusOficio.Autorizado) {
        state.bloquearCampos = true;
      }
      appBase.carregando = false;

      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        state.gerarPdf = true;
      }, 600);
    }

    async function limparDados() {
      state.apresentarCampos = false;
      state.bloquearCampos = false;
      state.gerarPdf = false;
      state.gerandoPdf = false;
      state.oficio = {} as IOficio;
      state.oficio.codigo = 0;
      state.oficio.data = await servicoApp.obterDataAtual();
      state.oficio.dataOficio = state.oficio.data;
      state.oficio.codigoUsuarioRegistro = storeApp.getters.codigoUsuarioAutenticado();
      state.oficio.conteudo = '<p><span style="font-size: 12.0pt;">Exmo. Sr.&nbsp;</span></p> <p><span style="font-size: 12.0pt;">Coordenador&nbsp;</span></p> <p><span style="font-size: 12.0pt;">Prezado Senhor</span></p> <p><span style="font-size: 12.0pt;">Cumprimentando-o(a) cordialmente, venho atrav&eacute;s deste requerimento,&nbsp;</span></p>';
      state.oficio.status = EStatusOficio.EmDigitacao;
      state.apresentarCampos = true;
    }

    onBeforeMount(async () => {
      limparDados();
      const codigooficio = obterCodigoRota();
      if (codigooficio > 0) {
        await obterOficio(codigooficio);
      }
    });

    async function salvar() {
      appBase.resposta = {} as IResposta;
      apresentarComunicacaoApi('Aguarde por favor... Estamos salvando as informações do oficio.');
      if (state.oficio.codigo === 0) {
        appBase.resposta = await servicoOficio.incluir(state.oficio);
      } else {
        appBase.resposta = await servicoOficio.atualizar(state.oficio);
      }
      if (appBase.resposta.status === EStatusResposta.Sucesso) {
        ocultarComunicacaoApi();
        if (state.oficio.codigo === 0) {
          apresentarMensagemSucesso('Ofício criado com sucesso!');
          await obterOficio(appBase.resposta.codigo);
        } else {
          apresentarMensagemSucesso('Ofício atualizado com sucesso!');
        }
        state.gerarPdf = true;
      }
    }

    async function gerarPdf() {
      state.gerandoPdf = true;
      const retornoRelatorio = await servicoOficio.gerarPdf(state.oficio.codigo);
      state.gerandoPdf = false;
      if (retornoRelatorio.status === EStatusResposta.Sucesso) {
        if (UtilitarioGeral.valorValido(retornoRelatorio.link)) {
          state.arquivosPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
        }
      } else {
        message.warn(retornoRelatorio.mensagem);
      }
    }

    async function atualizarStatus(status:EStatusOficio) {
      state.oficio.status = status;
      await salvar();
    }

    return {
      appBase,
      state,
      salvar,
      UtilitarioData,
      servicoOficio,
      atualizarStatus,
      EStatusOficio,
      gerarPdf,
      marcarAlterado,
    };
  },
});
